import React, { useEffect, useState } from "react";
import Logo from "../../assets/logo/logo.svg";

const seen = () => {
  try { return sessionStorage.getItem("ag-intro") === "1"; } catch (e) { return true; }
};

// Short brand intro, once per session. Skipped for reduced motion.
export default function Loader() {
  const skip = seen() || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  const [show, setShow] = useState(!skip);
  useEffect(() => {
    if (!show) return;
    try { sessionStorage.setItem("ag-intro", "1"); } catch (e) {}
    const t = setTimeout(() => setShow(false), 1500);
    return () => clearTimeout(t);
  }, [show]);
  if (!show) return null;
  return (
    <div className="ag-loader" aria-hidden="true">
      <img src={Logo} alt="" width="72" />
      <span>Alphabet Greens</span>
    </div>
  );
}
